function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Button } from "./Button";
export function IconedButton(_ref) {
  let {
    iconStyles,
    iconClassName,
    variant = 'text',
    icon,
    ...props
  } = _ref;
  const defaultIconClassName = "text-warning rounded-circle mx-auto";
  const passedIconClassName = iconClassName ? iconClassName : defaultIconClassName;
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: variant,
    className: "p-1 d-inline-flex rounded-circle text-warning"
  }, props, {
    iconClassName: passedIconClassName
  }), /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 blue"
  }, icon));
}
;